import { render, staticRenderFns } from "./TarafSifatiPicker.vue?vue&type=template&id=352a1e95"
import script from "./TarafSifatiPicker.vue?vue&type=script&lang=ts"
export * from "./TarafSifatiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports